import { render, staticRenderFns } from "./BaseErrorState.vue?vue&type=template&id=4b3637d2"
import script from "./BaseErrorState.vue?vue&type=script&lang=js"
export * from "./BaseErrorState.vue?vue&type=script&lang=js"
import style0 from "./BaseErrorState.vue?vue&type=style&index=0&id=4b3637d2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports